import { useEffect, useState } from "react"
import { CAP } from "../../../helpers/interfaces"
import { FormEditMode } from "../../../helpers/constants"

import CustomDialog from "../../CustomDialog"
import { CustomTextField } from "../../../layouts/themes"
import { Button } from "@mui/material"
import { Add } from "@mui/icons-material"
import { createCAP, updateCAP } from "../../../apiServices/GTBMappingKeysApi"


interface Props {
    setCAP:React.Dispatch<React.SetStateAction<CAP[]>>
    cap: CAP[]
    openCAPForm:boolean
    setFormEditMode:  React.Dispatch<React.SetStateAction<number>>
    setOpenCAPForm:React.Dispatch<React.SetStateAction<boolean>>
    capToEdit:string
    capEditMode:number
}
function CreateEditCAP(props: Props) {
    const [ capName, setCAPName] = useState<string>("");
    const [ capDesc, setCAPDesc] = useState<string>("");
    
    useEffect(() => {
        if (props.capEditMode === FormEditMode.EDIT) {
            var _capName = props.cap.find(e => e.id === props.capToEdit)
            if (!_capName) return
            setCAPName(_capName.code)
            setCAPDesc(_capName.description)
           
        }
    }, [props.cap, props.capEditMode, props.capToEdit])

    function createNewCAP() {
        createCAP( capName,capDesc ).then(_cfc=> {
            props.setOpenCAPForm(false);
            props.setCAP(cfc => [...cfc, _cfc])
            
        })
    }
    function capUpdate() {
        updateCAP(props.capToEdit,  capName,capDesc).then(result => {
            props.setOpenCAPForm(false);
            props.setCAP(cfc => cfc.map(a=> a.id === props.capToEdit ? result: a))
           
        })
    }
    return (
        <>
        <CustomDialog dialogTitle={props.capEditMode === FormEditMode.CREATE ? 'Add CAP ' : 'Update CAP '} setOpenDialog={props.setOpenCAPForm} openDialog={props.openCAPForm}>
            <form>
                <div >
                    <label className='title-label'>CAP Code <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="CAP Code" value={ capName} onChange={(e) => setCAPName(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
                <div >
                    <label className='title-label'>CAP Description <span className='important'>*</span></label>
                </div>
                <div className='col-12'>
                <div className="form-group mb-0">
                        <div className="">
                        <CustomTextField size="small" id="outlined-basic" placeholder="CAP Description" value={ capDesc} onChange={(e) => setCAPDesc(e.target.value)} variant="outlined" sx={{width:'100%'}}/> 
                            
                        </div>
                    </div>
                </div>
                <br />
               

                <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                    <Button disabled={! capName} variant="contained" color='secondary' onClick={props.capEditMode === FormEditMode.CREATE ? createNewCAP : capUpdate} >
                        <Add />&nbsp; {props.capEditMode === FormEditMode.CREATE ? 'Add New CAP' : 'Update CAP'}
                    </Button>
                </div>
            </form >


        </CustomDialog>

    </>
    )
}
export default CreateEditCAP